import { clampHsl, hslToRgb, rgbToHex, rgbToHsl, hexToRgb, withAlpha } from './colorUtils';

const scorePrimaryCandidate = color => {
  const rgb = hexToRgb(color.hex);
  if (!rgb) return -1;

  const hsl = rgbToHsl(rgb);
  const saturationScore = Math.min(100, hsl.s) / 100;
  const midLightScore = 1 - Math.abs(hsl.l - 45) / 45;

  return saturationScore * 0.65 + Math.max(0, midLightScore) * 0.35 + color.weight * 0.2;
};

const fromHsl = hsl => rgbToHex(hslToRgb(clampHsl(hsl)));

const pickPrimaryHex = palette => {
  if (!palette.length) return '#0a9e7b';

  return palette
    .map(item => ({ ...item, score: scorePrimaryCandidate(item) }))
    .sort((a, b) => b.score - a.score)[0].hex;
};

export const mapPaletteToTokens = ({ palette, baseTheme }) => {
  const xPrimarySeed = pickPrimaryHex(palette);
  const xPrimaryHsl = rgbToHsl(hexToRgb(xPrimarySeed));

  // const xBasePrimary = {
  //   h: xPrimaryHsl.h,
  //   s: Math.max(54, Math.min(78, xPrimaryHsl.s)),
  //   // Preserva melhor a identidade do logo sem cair em tom escuro demais no tema light.
  //   l: Math.max(42, Math.min(54, xPrimaryHsl.l))
  // };

  const xBasePrimary = {
    h: xPrimaryHsl.h,
    s: xPrimaryHsl.s,
    l: xPrimaryHsl.l
  };

  const xPrimaryMain = fromHsl(xBasePrimary);
  const xPrimaryLight = fromHsl({ ...xBasePrimary, l: xBasePrimary.l + 10 });
  const xPrimaryLightness = fromHsl({
    ...xBasePrimary,
    l: xBasePrimary.l + 22,
    s: xBasePrimary.s - 8
  });
  const xPrimaryDark = fromHsl({ ...xBasePrimary, l: xBasePrimary.l - 8 });
  const xPrimaryDarkness = fromHsl({
    ...xBasePrimary,
    l: xBasePrimary.l - 14,
    s: xBasePrimary.s - 6
  });

  const xSecondaryHue = (xPrimaryHsl.h + 145) % 360;
  const xSecondaryMain = fromHsl({ h: xSecondaryHue, s: 34, l: 79 });
  const xSecondaryDark = fromHsl({ h: xSecondaryHue, s: 36, l: 68 });
  const xSecondaryDarkness = fromHsl({ h: xSecondaryHue, s: 38, l: 57 });
  const xSecondaryLight = fromHsl({ h: xSecondaryHue, s: 28, l: 88 });
  const xSecondaryLightness = fromHsl({ h: xSecondaryHue, s: 30, l: 94 });

  return {
    primary: {
      ...baseTheme.colors.primary,
      lightness: xPrimaryLightness,
      light: xPrimaryLight,
      main: xPrimaryMain,
      dark: xPrimaryDark,
      darkness: xPrimaryDarkness,
      contrastText: '#ffffff'
    },
    secondary: {
      ...baseTheme.colors.secondary,
      lightness: xSecondaryLightness,
      light: xSecondaryLight,
      main: xSecondaryMain,
      dark: xSecondaryDark,
      darkness: xSecondaryDarkness,
      contrastText: 'rgba(0, 0, 0, .87)'
    },
    text: {
      ...baseTheme.colors.text,
      primary: withAlpha('#101323', 0.92),
      secondary: withAlpha('#33405f', 0.92),
      disabled: withAlpha('#6d7c9f', 0.92),
      disabledInvert: withAlpha('#101323', 0.38),
      hint: withAlpha('#5f6f91', 0.92)
    },
    divider: {
      ...baseTheme.colors.divider,
      main: 'rgba(24, 39, 75, 0.18)'
    },
    background: {
      ...baseTheme.colors.background,
      light: '#ffffff',
      main: '#eef2f8',
      dark: '#dde5f1',
      paper: '#ffffff',
      default: '#eef2f8',
      contrastText: '#101323'
    },
    background_theme_secondary: {
      ...baseTheme.colors.background_theme_secondary,
      light: '#ffffff',
      main: '#f4f7fd',
      dark: '#e9eff9',
      paper: 'rgba(255, 255, 255, 1)',
      default: 'rgba(244, 247, 253, 1)',
      contrastText: '#101323'
    }
  };
};

export default mapPaletteToTokens;
